// @see https://qiita.com/dich1/items/4878ba4b089b3fe7ff30

const Enum = function() {
  this._enums = []
}

Enum.prototype.getList = function() {
  return this._enums
}

Enum.prototype.addEnum = function(e) {
  this._enums.push(e)
}

Enum.prototype.getByName = function(name) {
  return this[name]
}

Enum.prototype.getByValue = function(value) {
  for (let index = 0; index < this._enums.length; index++) {
    const row = this._enums[index]
    if (row.value === value) {
      return row
    }
  }
}

export const defineEnum = (definition) => {
  let k
  const e = new Enum()
  for (k in definition) {
    const j = definition[k]
    e[k] = j
    e.addEnum(j)
  }
  return e
}
